import type { RegExpGroups } from "./RegExpGroups";
import type { MetadataMatch } from "./types";
import { JiraIcon } from "ls/features/disko/icons";
import JiraInlineCard from "./JiraInlineCard.vue";

export type JiraMetadataMatch = MetadataMatch & {
  name: "jira";
  key: string;
};

const patterns = [
  /^(https:\/\/)?[^/]+\.((atlassian|atl-paas)\.net|jira\.com)\/browse\/(?<key>[a-z0-9]+-\d+)#?.*?\/?$/i,
] as const;

export function jira(url: string): JiraMetadataMatch | undefined {
  for (const pattern of patterns) {
    const result = url.match(pattern) as RegExpGroups<"key">;
    if (!result) continue;

    const key = result.groups?.key.toUpperCase();
    if (!key) continue;

    return {
      name: "jira",
      url,
      key,
      icon: JiraIcon,
      inlineCard: JiraInlineCard,
    };
  }

  return undefined;
}
